/**
 * Display formatting for cent-denominated prices.
 *
 * The credit pack price is env-configurable (CREDIT_PACK_PRICE_CENTS) and is
 * not guaranteed to be a whole number of dollars. The previous inline
 * `(cents / 100).toFixed(0)` rounded the cents away, so a pack priced at 1999
 * advertised "$20" while Stripe charged $19.99 — the funnel guard proves the
 * label *derives* from the configured value, not that the number the buyer
 * reads is the number they are charged.
 *
 * Whole-dollar prices keep their bare form ("$49", not "$49.00") so existing
 * CTA copy is unchanged.
 */
export function formatPriceFromCents(cents: number): string {
  const safe = Number.isFinite(cents) ? Math.max(0, Math.round(cents)) : 0;
  return safe % 100 === 0 ? `$${safe / 100}` : `$${(safe / 100).toFixed(2)}`;
}

/**
 * What one purchase buys, for buy-control labels ("Buy 1 full audit — $49").
 *
 * The pack size is env-configurable (CREDITS_PER_PURCHASE) and reaches the
 * frontend only through GET /api/credits, so labels interpolate it rather
 * than restate it. Issue #1311 took the default from 50 credits to 1, which
 * the old "Buy {n} URL audits" wording rendered as "Buy 1 URL audits"; the
 * singular lives here so every label gets it.
 */
export function formatPackContents(credits: number): string {
  return credits === 1 ? '1 full audit' : `${credits} full audits`;
}
